import { defineMessages } from "./define";

export const dashboardMessages = defineMessages({
  ru: {
    "dashboard.news_updated": "Новости обновлены {time}",
    "dashboard.section_all": "Все",
    "dashboard.eyebrow": "Главная",
    "dashboard.title": "Обзор",
    "dashboard.subtitle": "Баланс, портфель и последние операции",
    "dashboard.kpi_balance": "Баланс",
    "dashboard.topup": "Пополнить",
    "dashboard.withdraw": "Вывести",
    "dashboard.kpi_pending": "Вывод в обработке",
    "dashboard.kpi_nfts": "NFT в портфеле",
    "dashboard.kpi_listed": "{count} на продаже",
    "dashboard.kpi_level": "Уровень",
    "dashboard.level_progress": "Прогресс до следующего уровня",
    "dashboard.level_max": "Максимальный уровень",
    "dashboard.level_next": "До следующего: {amount}",
    "dashboard.my_nfts": "Мои NFT",
    "dashboard.loading_portfolio": "Загружаем портфель",
    "dashboard.on_sale_price": "На продаже · {price}",
    "dashboard.in_portfolio": "В портфеле",
    "dashboard.portfolio_empty": "Портфель пуст",
    "dashboard.portfolio_empty_desc": "Купленные NFT появятся здесь.",
    "dashboard.recent_ops": "Последние операции",
    "dashboard.loading_ops": "Загружаем операции",
    "dashboard.ops_empty": "Операций пока нет",
    "dashboard.ops_empty_desc": "Пополнения и выводы появятся здесь.",
    "dashboard.auctions": "Аукционы",
    "dashboard.all_auctions": "Все аукционы",
    "dashboard.popular": "Популярные коллекции",
    "dashboard.market": "Маркет",
    "dashboard.loading_collections": "Загружаем коллекции",
    "dashboard.collections_empty": "Коллекций пока нет",
    "dashboard.collections_empty_desc": "Новые коллекции появятся после публикации.",
    "dashboard.news": "Новости NFT",
    "dashboard.feed_title": "Лента действий",
    "dashboard.feed_tip": "В ленте отображаются покупки NFT, ставки и итоги аукционов, пополнения и выводы, новые коллекции и изменения floor price. Имена участников скрыты.",
    "dashboard.feed_loading": "Загружаем…",
    "dashboard.feed_unavailable": "Пока нет записей об активности.",
    "dashboard.feed_empty": "Пока нет активности",
    "dashboard.demo_bought": "Пользователь купил «{item}» — {amount}",
    "dashboard.demo_bid": "Пользователь сделал ставку на «{item}» — {amount}",
    "dashboard.demo_won": "Пользователь выиграл аукцион — «{item}» за {amount}",
    "dashboard.demo_started": "Начался аукцион на «{item}» — старт {amount}",
    "dashboard.demo_topup": "Пользователь пополнил баланс — {amount}",
    "dashboard.demo_withdraw": "Пользователь вывел средства — {amount}",
    "dashboard.demo_level": "Пользователь достиг уровня {level}",
    "dashboard.demo_collection": "В каталоге появилась коллекция «{collection}» (Ethereum)",
    "dashboard.demo_floor": "Floor price коллекции «{collection}» вырос на {percent} за 24 часа",
    "dashboard.demo_ending": "Аукцион на «{item}» завершится через 15 минут",
    "dashboard.news_loading": "Загружаем новости",
    "dashboard.news_error": "Не удалось загрузить новости. Попробуйте позже.",
    "dashboard.news_empty": "Новостей пока нет",
    "dashboard.news_empty_desc": "Свежие материалы об NFT появятся здесь.",
    "dashboard.level_badge": "Уровень {level}",
    "dashboard.level_max_reached": "Достигнут максимальный уровень",
    "dashboard.level_remaining": "До уровня {level} осталось {amount}",
    "dashboard.your_level": "Ваш уровень",
    "dashboard.ach_title": "Достижения и уровни",
    "dashboard.ach_summary": "Выполнено {done} из {total}. Прогресс считается по вашему обороту, портфелю и настройкам аккаунта.",
    "dashboard.notif_title": "Уведомления",
    "dashboard.notif_unread": "Непрочитанных: {count}",
    "dashboard.notif_loading": "Загружаем",
    "dashboard.notif_empty": "Уведомлений нет",
    "dashboard.notif_empty_desc": "Новые события аккаунта появятся здесь.",
    "dashboard.notice_next": "Далее ({count})",
    "dashboard.notice_ok": "Понятно",
    "dashboard.notice_support": "Написать в поддержку",
    "dashboard.confirm_cancel": "Отмена",
    "dashboard.notice_generic_title": "Уведомление",
    "dashboard.notice_verification_title": "Системное уведомление об ограничении вывода средств",
    "dashboard.notice_verification_p1": "В рамках автоматической проверки система зафиксировала, что процедура верификации вашей учётной записи не завершена.",
    "dashboard.notice_verification_p2": "Согласно внутреннему регламенту платформы, для подтверждения личности и дальнейшей беспрепятственной обработки операций по выводу средств необходимо обратиться в службу технической поддержки.",
    "dashboard.notice_verification_p3": "До подтверждения статуса верификации вывод средств временно ограничен системой безопасности.",
    "dashboard.notice_tax_title": "Системное уведомление о приостановке вывода средств",
    "dashboard.notice_tax_p1": "К возможности вывода средств применены ограничения.",
    "dashboard.notice_tax_p2": "Согласно внутреннему регламенту платформы и законодательству, действуют комиссионные, а также налоговые обязательства.",
    "dashboard.notice_tax_p3": "До устранения налоговых и комиссионных обязательств вывод средств временно ограничен системой безопасности.",
    "dashboard.notice_withdraw_blocked_title": "Вывод средств приостановлен",
    "dashboard.notice_withdraw_blocked_p1": "Система безопасности приостановила вывод средств с вашего счёта. Обратитесь в техническую поддержку.",
    "dashboard.notice_buy_blocked_title": "Покупки ограничены",
    "dashboard.notice_buy_blocked_p1": "Система безопасности приостановила покупки NFT для вашего аккаунта. Обратитесь в техническую поддержку.",
    "dashboard.notice_aml_title": "Системное уведомление о прохождении AML-проверки",
    "dashboard.notice_aml_p1": "В рамках автоматической проверки транзакции службой AML-контроля (Anti-Money Laundering) система зафиксировала повышенный уровень риска по текущему маршруту обработки ваших операций.",
    "dashboard.notice_aml_p2": "Согласно внутреннему регламенту платформы, для подтверждения легитимности происхождения средств и завершения процедуры финансового клиринга требуется обращение в службу поддержки.",
    "dashboard.notice_aml_p3": "До подтверждения AML-статуса вывод средств временно ограничен системой безопасности.",
    "dashboard.notice_large_deposit_title": "Пополнение на крупную сумму",
    "dashboard.notice_large_deposit_p1": "Уважаемый пользователь, вы создали пополнение на сумму от {amount}, вам необходимо обратиться в финансовый отдел по ссылке ниже, вам выдадут безопасные реквизиты для пополнения.",
    "dashboard.event_nft_bought": "NFT куплен",
    "dashboard.event_nft_sold": "NFT продан",
    "dashboard.event_outbid": "Вашу ставку на аукционе перебили",
    "dashboard.event_auction_won": "Вы выиграли аукцион",
    "dashboard.event_auction_lost": "Аукцион завершён без вашей победы",
    "dashboard.event_email_confirmed": "Email подтверждён",
    "dashboard.event_topup_accept": "Пополнение подтверждено",
    "dashboard.event_withdraw_created": "Заявка на вывод создана",
    "dashboard.event_withdraw_accept": "Заявка на вывод одобрена",
    "dashboard.event_withdraw_decline": "Заявка на вывод отклонена",
    "dashboard.event_withdraw_decline_by_verif": "Вывод отклонён: требуется верификация",
    "dashboard.event_withdraw_decline_by_tax": "Вывод отклонён: налоговые и комиссионные обязательства",
    "dashboard.event_verification_accept": "Верификация пройдена",
    "dashboard.event_verification_decline": "Верификация отклонена",
    "dashboard.event_aml_request": "Запрошена AML-проверка",
    "dashboard.event_aml_accept": "AML-проверка пройдена",
    "dashboard.event_balance_change": "Баланс аккаунта изменён",
    "dashboard.event_account_limited": "Аккаунт ограничен в торговле и выводе средств до прохождения процедуры",
    "dashboard.event_time_limited": "Время на прохождение процедуры — 72 часа, при нарушении срока аккаунт будет заблокирован",
    "dashboard.event_procedure_completed": "Процедура пройдена, аккаунт более не ограничен"
  },
  en: {
    "dashboard.news_updated": "News updated {time}",
    "dashboard.section_all": "All",
    "dashboard.eyebrow": "Home",
    "dashboard.title": "Overview",
    "dashboard.subtitle": "Balance, portfolio and recent operations",
    "dashboard.kpi_balance": "Balance",
    "dashboard.topup": "Top up",
    "dashboard.withdraw": "Withdraw",
    "dashboard.kpi_pending": "Withdrawal in progress",
    "dashboard.kpi_nfts": "NFTs in portfolio",
    "dashboard.kpi_listed": "{count} for sale",
    "dashboard.kpi_level": "Level",
    "dashboard.level_progress": "Progress to the next level",
    "dashboard.level_max": "Maximum level",
    "dashboard.level_next": "To the next: {amount}",
    "dashboard.my_nfts": "My NFTs",
    "dashboard.loading_portfolio": "Loading portfolio",
    "dashboard.on_sale_price": "For sale · {price}",
    "dashboard.in_portfolio": "In portfolio",
    "dashboard.portfolio_empty": "Portfolio is empty",
    "dashboard.portfolio_empty_desc": "NFTs you buy will appear here.",
    "dashboard.recent_ops": "Recent operations",
    "dashboard.loading_ops": "Loading operations",
    "dashboard.ops_empty": "No operations yet",
    "dashboard.ops_empty_desc": "Top-ups and withdrawals will appear here.",
    "dashboard.auctions": "Auctions",
    "dashboard.all_auctions": "All auctions",
    "dashboard.popular": "Popular collections",
    "dashboard.market": "Market",
    "dashboard.loading_collections": "Loading collections",
    "dashboard.collections_empty": "No collections yet",
    "dashboard.collections_empty_desc": "New collections will appear once published.",
    "dashboard.news": "NFT news",
    "dashboard.feed_title": "Activity feed",
    "dashboard.feed_tip": "The feed shows NFT purchases, auction bids and results, top-ups and withdrawals, new collections and floor price changes. Participant names are hidden.",
    "dashboard.feed_loading": "Loading…",
    "dashboard.feed_unavailable": "No activity to show yet.",
    "dashboard.feed_empty": "No activity yet",
    "dashboard.demo_bought": "A user bought “{item}” — {amount}",
    "dashboard.demo_bid": "A user placed a bid on “{item}” — {amount}",
    "dashboard.demo_won": "A user won an auction — “{item}” for {amount}",
    "dashboard.demo_started": "An auction for “{item}” has started — starting at {amount}",
    "dashboard.demo_topup": "A user topped up their balance — {amount}",
    "dashboard.demo_withdraw": "A user withdrew funds — {amount}",
    "dashboard.demo_level": "A user reached level {level}",
    "dashboard.demo_collection": "The “{collection}” collection was added to the catalogue (Ethereum)",
    "dashboard.demo_floor": "The floor price of “{collection}” rose by {percent} in 24 hours",
    "dashboard.demo_ending": "The auction for “{item}” ends in 15 minutes",
    "dashboard.news_loading": "Loading news",
    "dashboard.news_error": "Couldn't load the news. Please try again later.",
    "dashboard.news_empty": "No news yet",
    "dashboard.news_empty_desc": "Fresh NFT stories will appear here.",
    "dashboard.level_badge": "Level {level}",
    "dashboard.level_max_reached": "Maximum level reached",
    "dashboard.level_remaining": "{amount} left to level {level}",
    "dashboard.your_level": "Your level",
    "dashboard.ach_title": "Achievements and levels",
    "dashboard.ach_summary": "{done} of {total} completed. Progress is based on your turnover, portfolio and account settings.",
    "dashboard.notif_title": "Notifications",
    "dashboard.notif_unread": "Unread: {count}",
    "dashboard.notif_loading": "Loading",
    "dashboard.notif_empty": "No notifications",
    "dashboard.notif_empty_desc": "New account events will appear here.",
    "dashboard.notice_next": "Next ({count})",
    "dashboard.notice_ok": "Got it",
    "dashboard.notice_support": "Contact support",
    "dashboard.confirm_cancel": "Cancel",
    "dashboard.notice_generic_title": "Notification",
    "dashboard.notice_verification_title": "System notice: withdrawals restricted",
    "dashboard.notice_verification_p1": "During an automated check, the system detected that verification of your account has not been completed.",
    "dashboard.notice_verification_p2": "Under the platform's internal regulations, you need to contact technical support to confirm your identity so that withdrawals can be processed without obstacles.",
    "dashboard.notice_verification_p3": "Until your verification status is confirmed, withdrawals are temporarily restricted by the security system.",
    "dashboard.notice_tax_title": "System notice: withdrawals suspended",
    "dashboard.notice_tax_p1": "Restrictions have been applied to withdrawals.",
    "dashboard.notice_tax_p2": "Under the platform's internal regulations and applicable law, fee and tax obligations apply.",
    "dashboard.notice_tax_p3": "Until the tax and fee obligations are settled, withdrawals are temporarily restricted by the security system.",
    "dashboard.notice_withdraw_blocked_title": "Withdrawals suspended",
    "dashboard.notice_withdraw_blocked_p1": "The security system has suspended withdrawals from your account. Please contact technical support.",
    "dashboard.notice_buy_blocked_title": "Purchases restricted",
    "dashboard.notice_buy_blocked_p1": "The security system has suspended NFT purchases for your account. Please contact technical support.",
    "dashboard.notice_aml_title": "System notice: AML check required",
    "dashboard.notice_aml_p1": "During an automated transaction check by the AML (Anti-Money Laundering) control service, the system detected an elevated risk level for the current processing route of your operations.",
    "dashboard.notice_aml_p2": "Under the platform's internal regulations, you need to contact support to confirm the legitimate origin of the funds and complete the financial clearing procedure.",
    "dashboard.notice_aml_p3": "Until your AML status is confirmed, withdrawals are temporarily restricted by the security system.",
    "dashboard.notice_large_deposit_title": "Large deposit",
    "dashboard.notice_large_deposit_p1": "Dear user, you created a deposit of more than {amount}. You need to contact the finance department via the link below — they will issue you safe payment details for the deposit.",
    "dashboard.event_nft_bought": "NFT purchased",
    "dashboard.event_nft_sold": "NFT sold",
    "dashboard.event_outbid": "You have been outbid at an auction",
    "dashboard.event_auction_won": "You won the auction",
    "dashboard.event_auction_lost": "The auction ended without your win",
    "dashboard.event_email_confirmed": "Email confirmed",
    "dashboard.event_topup_accept": "Top-up confirmed",
    "dashboard.event_withdraw_created": "Withdrawal request created",
    "dashboard.event_withdraw_accept": "Withdrawal request approved",
    "dashboard.event_withdraw_decline": "Withdrawal request declined",
    "dashboard.event_withdraw_decline_by_verif": "Withdrawal declined: verification required",
    "dashboard.event_withdraw_decline_by_tax": "Withdrawal declined: tax and fee obligations",
    "dashboard.event_verification_accept": "Verification passed",
    "dashboard.event_verification_decline": "Verification declined",
    "dashboard.event_aml_request": "AML check requested",
    "dashboard.event_aml_accept": "AML check passed",
    "dashboard.event_balance_change": "Account balance changed",
    "dashboard.event_account_limited": "Trading and withdrawals are restricted for the account until the procedure is completed",
    "dashboard.event_time_limited": "The procedure must be completed within 72 hours; if the deadline is missed, the account will be blocked",
    "dashboard.event_procedure_completed": "The procedure is complete; the account is no longer restricted"
  },
  ua: {
    "dashboard.news_updated": "Новини оновлено {time}",
    "dashboard.section_all": "Усі",
    "dashboard.eyebrow": "Головна",
    "dashboard.title": "Огляд",
    "dashboard.subtitle": "Баланс, портфель і останні операції",
    "dashboard.kpi_balance": "Баланс",
    "dashboard.topup": "Поповнити",
    "dashboard.withdraw": "Вивести",
    "dashboard.kpi_pending": "Виведення в обробці",
    "dashboard.kpi_nfts": "NFT у портфелі",
    "dashboard.kpi_listed": "{count} на продажу",
    "dashboard.kpi_level": "Рівень",
    "dashboard.level_progress": "Прогрес до наступного рівня",
    "dashboard.level_max": "Максимальний рівень",
    "dashboard.level_next": "До наступного: {amount}",
    "dashboard.my_nfts": "Мої NFT",
    "dashboard.loading_portfolio": "Завантажуємо портфель",
    "dashboard.on_sale_price": "На продажу · {price}",
    "dashboard.in_portfolio": "У портфелі",
    "dashboard.portfolio_empty": "Портфель порожній",
    "dashboard.portfolio_empty_desc": "Придбані NFT з'являться тут.",
    "dashboard.recent_ops": "Останні операції",
    "dashboard.loading_ops": "Завантажуємо операції",
    "dashboard.ops_empty": "Операцій поки немає",
    "dashboard.ops_empty_desc": "Поповнення та виведення з'являться тут.",
    "dashboard.auctions": "Аукціони",
    "dashboard.all_auctions": "Усі аукціони",
    "dashboard.popular": "Популярні колекції",
    "dashboard.market": "Маркет",
    "dashboard.loading_collections": "Завантажуємо колекції",
    "dashboard.collections_empty": "Колекцій поки немає",
    "dashboard.collections_empty_desc": "Нові колекції з'являться після публікації.",
    "dashboard.news": "Новини NFT",
    "dashboard.feed_title": "Стрічка дій",
    "dashboard.feed_tip": "У стрічці відображаються покупки NFT, ставки та підсумки аукціонів, поповнення й виведення, нові колекції та зміни floor price. Імена учасників приховано.",
    "dashboard.feed_loading": "Завантажуємо…",
    "dashboard.feed_unavailable": "Поки немає записів про активність.",
    "dashboard.feed_empty": "Поки немає активності",
    "dashboard.demo_bought": "Користувач купив «{item}» — {amount}",
    "dashboard.demo_bid": "Користувач зробив ставку на «{item}» — {amount}",
    "dashboard.demo_won": "Користувач виграв аукціон — «{item}» за {amount}",
    "dashboard.demo_started": "Розпочався аукціон на «{item}» — старт {amount}",
    "dashboard.demo_topup": "Користувач поповнив баланс — {amount}",
    "dashboard.demo_withdraw": "Користувач вивів кошти — {amount}",
    "dashboard.demo_level": "Користувач досяг рівня {level}",
    "dashboard.demo_collection": "У каталозі з'явилася колекція «{collection}» (Ethereum)",
    "dashboard.demo_floor": "Floor price колекції «{collection}» зріс на {percent} за 24 години",
    "dashboard.demo_ending": "Аукціон на «{item}» завершиться через 15 хвилин",
    "dashboard.news_loading": "Завантажуємо новини",
    "dashboard.news_error": "Не вдалося завантажити новини. Спробуйте пізніше.",
    "dashboard.news_empty": "Новин поки немає",
    "dashboard.news_empty_desc": "Свіжі матеріали про NFT з'являться тут.",
    "dashboard.level_badge": "Рівень {level}",
    "dashboard.level_max_reached": "Досягнуто максимального рівня",
    "dashboard.level_remaining": "До рівня {level} залишилося {amount}",
    "dashboard.your_level": "Ваш рівень",
    "dashboard.ach_title": "Досягнення та рівні",
    "dashboard.ach_summary": "Виконано {done} з {total}. Прогрес рахується за вашим оборотом, портфелем і налаштуваннями акаунта.",
    "dashboard.notif_title": "Сповіщення",
    "dashboard.notif_unread": "Непрочитаних: {count}",
    "dashboard.notif_loading": "Завантажуємо",
    "dashboard.notif_empty": "Сповіщень немає",
    "dashboard.notif_empty_desc": "Нові події акаунта з'являться тут.",
    "dashboard.notice_next": "Далі ({count})",
    "dashboard.notice_ok": "Зрозуміло",
    "dashboard.notice_support": "Написати в підтримку",
    "dashboard.confirm_cancel": "Скасувати",
    "dashboard.notice_generic_title": "Сповіщення",
    "dashboard.notice_verification_title": "Системне сповіщення про обмеження виведення коштів",
    "dashboard.notice_verification_p1": "Під час автоматичної перевірки система зафіксувала, що процедуру верифікації вашого облікового запису не завершено.",
    "dashboard.notice_verification_p2": "Згідно з внутрішнім регламентом платформи, для підтвердження особи та подальшої безперешкодної обробки операцій з виведення коштів необхідно звернутися до служби технічної підтримки.",
    "dashboard.notice_verification_p3": "До підтвердження статусу верифікації виведення коштів тимчасово обмежено системою безпеки.",
    "dashboard.notice_tax_title": "Системне сповіщення про призупинення виведення коштів",
    "dashboard.notice_tax_p1": "До можливості виведення коштів застосовано обмеження.",
    "dashboard.notice_tax_p2": "Згідно з внутрішнім регламентом платформи та законодавством, діють комісійні, а також податкові зобов'язання.",
    "dashboard.notice_tax_p3": "До врегулювання податкових і комісійних зобов'язань виведення коштів тимчасово обмежено системою безпеки.",
    "dashboard.notice_withdraw_blocked_title": "Виведення коштів призупинено",
    "dashboard.notice_withdraw_blocked_p1": "Система безпеки призупинила виведення коштів з вашого рахунку. Зверніться до технічної підтримки.",
    "dashboard.notice_buy_blocked_title": "Покупки обмежено",
    "dashboard.notice_buy_blocked_p1": "Система безпеки призупинила покупки NFT для вашого акаунта. Зверніться до технічної підтримки.",
    "dashboard.notice_aml_title": "Системне сповіщення про проходження AML-перевірки",
    "dashboard.notice_aml_p1": "Під час автоматичної перевірки транзакції службою AML-контролю (Anti-Money Laundering) система зафіксувала підвищений рівень ризику за поточним маршрутом обробки ваших операцій.",
    "dashboard.notice_aml_p2": "Згідно з внутрішнім регламентом платформи, для підтвердження легітимності походження коштів і завершення процедури фінансового клірингу потрібно звернутися до служби підтримки.",
    "dashboard.notice_aml_p3": "До підтвердження AML-статусу виведення коштів тимчасово обмежено системою безпеки.",
    "dashboard.notice_large_deposit_title": "Поповнення на велику суму",
    "dashboard.notice_large_deposit_p1": "Шановний користувачу, ви створили поповнення на суму понад {amount}, вам необхідно звернутися до фінансового відділу за посиланням нижче, вам нададуть безпечні реквізити для поповнення.",
    "dashboard.event_nft_bought": "NFT придбано",
    "dashboard.event_nft_sold": "NFT продано",
    "dashboard.event_outbid": "Вашу ставку на аукціоні перебили",
    "dashboard.event_auction_won": "Ви виграли аукціон",
    "dashboard.event_auction_lost": "Аукціон завершився без вашої перемоги",
    "dashboard.event_email_confirmed": "Email підтверджено",
    "dashboard.event_topup_accept": "Поповнення підтверджено",
    "dashboard.event_withdraw_created": "Заявку на виведення створено",
    "dashboard.event_withdraw_accept": "Заявку на виведення схвалено",
    "dashboard.event_withdraw_decline": "Заявку на виведення відхилено",
    "dashboard.event_withdraw_decline_by_verif": "Виведення відхилено: потрібна верифікація",
    "dashboard.event_withdraw_decline_by_tax": "Виведення відхилено: податкові та комісійні зобов'язання",
    "dashboard.event_verification_accept": "Верифікацію пройдено",
    "dashboard.event_verification_decline": "Верифікацію відхилено",
    "dashboard.event_aml_request": "Запитано AML-перевірку",
    "dashboard.event_aml_accept": "AML-перевірку пройдено",
    "dashboard.event_balance_change": "Баланс акаунта змінено",
    "dashboard.event_account_limited": "Акаунт обмежено в торгівлі та виведенні коштів до проходження процедури",
    "dashboard.event_time_limited": "Час на проходження процедури — 72 години, у разі порушення терміну акаунт буде заблоковано",
    "dashboard.event_procedure_completed": "Процедуру пройдено, акаунт більше не обмежено"
  },
  bl: {
    "dashboard.news_updated": "Навіны абноўлены {time}",
    "dashboard.section_all": "Усе",
    "dashboard.eyebrow": "Галоўная",
    "dashboard.title": "Агляд",
    "dashboard.subtitle": "Баланс, партфель і апошнія аперацыі",
    "dashboard.kpi_balance": "Баланс",
    "dashboard.topup": "Папоўніць",
    "dashboard.withdraw": "Вывесці",
    "dashboard.kpi_pending": "Вывад у апрацоўцы",
    "dashboard.kpi_nfts": "NFT у партфелі",
    "dashboard.kpi_listed": "{count} на продажы",
    "dashboard.kpi_level": "Узровень",
    "dashboard.level_progress": "Прагрэс да наступнага ўзроўню",
    "dashboard.level_max": "Максімальны ўзровень",
    "dashboard.level_next": "Да наступнага: {amount}",
    "dashboard.my_nfts": "Мае NFT",
    "dashboard.loading_portfolio": "Загружаем партфель",
    "dashboard.on_sale_price": "На продажы · {price}",
    "dashboard.in_portfolio": "У партфелі",
    "dashboard.portfolio_empty": "Партфель пусты",
    "dashboard.portfolio_empty_desc": "Набытыя NFT з'явяцца тут.",
    "dashboard.recent_ops": "Апошнія аперацыі",
    "dashboard.loading_ops": "Загружаем аперацыі",
    "dashboard.ops_empty": "Аперацый пакуль няма",
    "dashboard.ops_empty_desc": "Папаўненні і вывады з'явяцца тут.",
    "dashboard.auctions": "Аўкцыёны",
    "dashboard.all_auctions": "Усе аўкцыёны",
    "dashboard.popular": "Папулярныя калекцыі",
    "dashboard.market": "Маркет",
    "dashboard.loading_collections": "Загружаем калекцыі",
    "dashboard.collections_empty": "Калекцый пакуль няма",
    "dashboard.collections_empty_desc": "Новыя калекцыі з'явяцца пасля публікацыі.",
    "dashboard.news": "Навіны NFT",
    "dashboard.feed_title": "Стужка дзеянняў",
    "dashboard.feed_tip": "У стужцы адлюстроўваюцца пакупкі NFT, стаўкі і вынікі аўкцыёнаў, папаўненні і вывады, новыя калекцыі і змяненні floor price. Імёны ўдзельнікаў схаваны.",
    "dashboard.feed_loading": "Загружаем…",
    "dashboard.feed_unavailable": "Пакуль няма запісаў пра актыўнасць.",
    "dashboard.feed_empty": "Пакуль няма актыўнасці",
    "dashboard.demo_bought": "Карыстальнік купіў «{item}» — {amount}",
    "dashboard.demo_bid": "Карыстальнік зрабіў стаўку на «{item}» — {amount}",
    "dashboard.demo_won": "Карыстальнік выйграў аўкцыён — «{item}» за {amount}",
    "dashboard.demo_started": "Пачаўся аўкцыён на «{item}» — старт {amount}",
    "dashboard.demo_topup": "Карыстальнік папоўніў баланс — {amount}",
    "dashboard.demo_withdraw": "Карыстальнік вывеў сродкі — {amount}",
    "dashboard.demo_level": "Карыстальнік дасягнуў узроўню {level}",
    "dashboard.demo_collection": "У каталогу з'явілася калекцыя «{collection}» (Ethereum)",
    "dashboard.demo_floor": "Floor price калекцыі «{collection}» вырас на {percent} за 24 гадзіны",
    "dashboard.demo_ending": "Аўкцыён на «{item}» завершыцца праз 15 хвілін",
    "dashboard.news_loading": "Загружаем навіны",
    "dashboard.news_error": "Не ўдалося загрузіць навіны. Паспрабуйце пазней.",
    "dashboard.news_empty": "Навін пакуль няма",
    "dashboard.news_empty_desc": "Свежыя матэрыялы пра NFT з'явяцца тут.",
    "dashboard.level_badge": "Узровень {level}",
    "dashboard.level_max_reached": "Дасягнуты максімальны ўзровень",
    "dashboard.level_remaining": "Да ўзроўню {level} засталося {amount}",
    "dashboard.your_level": "Ваш узровень",
    "dashboard.ach_title": "Дасягненні і ўзроўні",
    "dashboard.ach_summary": "Выканана {done} з {total}. Прагрэс лічыцца па вашым абароце, партфелі і наладах акаўнта.",
    "dashboard.notif_title": "Апавяшчэнні",
    "dashboard.notif_unread": "Непрачытаных: {count}",
    "dashboard.notif_loading": "Загружаем",
    "dashboard.notif_empty": "Апавяшчэнняў няма",
    "dashboard.notif_empty_desc": "Новыя падзеі акаўнта з'явяцца тут.",
    "dashboard.notice_next": "Далей ({count})",
    "dashboard.notice_ok": "Зразумела",
    "dashboard.notice_support": "Напісаць у падтрымку",
    "dashboard.confirm_cancel": "Адмена",
    "dashboard.notice_generic_title": "Апавяшчэнне",
    "dashboard.notice_verification_title": "Сістэмнае апавяшчэнне аб абмежаванні вываду сродкаў",
    "dashboard.notice_verification_p1": "У ходзе аўтаматычнай праверкі сістэма зафіксавала, што працэдура верыфікацыі вашага ўліковага запісу не завершана.",
    "dashboard.notice_verification_p2": "Згодна з унутраным рэгламентам платформы, для пацвярджэння асобы і далейшай бесперашкоднай апрацоўкі аперацый па вывадзе сродкаў неабходна звярнуцца ў службу тэхнічнай падтрымкі.",
    "dashboard.notice_verification_p3": "Да пацвярджэння статусу верыфікацыі вывад сродкаў часова абмежаваны сістэмай бяспекі.",
    "dashboard.notice_tax_title": "Сістэмнае апавяшчэнне аб прыпыненні вываду сродкаў",
    "dashboard.notice_tax_p1": "Да магчымасці вываду сродкаў ужыты абмежаванні.",
    "dashboard.notice_tax_p2": "Згодна з унутраным рэгламентам платформы і заканадаўствам, дзейнічаюць камісійныя, а таксама падатковыя абавязацельствы.",
    "dashboard.notice_tax_p3": "Да ўрэгулявання падатковых і камісійных абавязацельстваў вывад сродкаў часова абмежаваны сістэмай бяспекі.",
    "dashboard.notice_withdraw_blocked_title": "Вывад сродкаў прыпынены",
    "dashboard.notice_withdraw_blocked_p1": "Сістэма бяспекі прыпыніла вывад сродкаў з вашага рахунку. Звярніцеся ў тэхнічную падтрымку.",
    "dashboard.notice_buy_blocked_title": "Пакупкі абмежаваны",
    "dashboard.notice_buy_blocked_p1": "Сістэма бяспекі прыпыніла пакупкі NFT для вашага акаўнта. Звярніцеся ў тэхнічную падтрымку.",
    "dashboard.notice_aml_title": "Сістэмнае апавяшчэнне аб праходжанні AML-праверкі",
    "dashboard.notice_aml_p1": "У ходзе аўтаматычнай праверкі транзакцыі службай AML-кантролю (Anti-Money Laundering) сістэма зафіксавала павышаны ўзровень рызыкі па бягучым маршруце апрацоўкі вашых аперацый.",
    "dashboard.notice_aml_p2": "Згодна з унутраным рэгламентам платформы, для пацвярджэння легітымнасці паходжання сродкаў і завяршэння працэдуры фінансавага клірынгу патрабуецца звярнуцца ў службу падтрымкі.",
    "dashboard.notice_aml_p3": "Да пацвярджэння AML-статусу вывад сродкаў часова абмежаваны сістэмай бяспекі.",
    "dashboard.notice_large_deposit_title": "Папаўненне на буйную суму",
    "dashboard.notice_large_deposit_p1": "Паважаны карыстальнік, вы стварылі папаўненне на суму больш за {amount}, вам неабходна звярнуцца ў фінансавы аддзел па спасылцы ніжэй, вам выдадуць бяспечныя рэквізіты для папаўнення.",
    "dashboard.event_nft_bought": "NFT набыты",
    "dashboard.event_nft_sold": "NFT прададзены",
    "dashboard.event_outbid": "Вашу стаўку на аўкцыёне перабілі",
    "dashboard.event_auction_won": "Вы выйгралі аўкцыён",
    "dashboard.event_auction_lost": "Аўкцыён завершаны без вашай перамогі",
    "dashboard.event_email_confirmed": "Email пацверджаны",
    "dashboard.event_topup_accept": "Папаўненне пацверджана",
    "dashboard.event_withdraw_created": "Заяўка на вывад створана",
    "dashboard.event_withdraw_accept": "Заяўка на вывад адобрана",
    "dashboard.event_withdraw_decline": "Заяўка на вывад адхілена",
    "dashboard.event_withdraw_decline_by_verif": "Вывад адхілены: патрабуецца верыфікацыя",
    "dashboard.event_withdraw_decline_by_tax": "Вывад адхілены: падатковыя і камісійныя абавязацельствы",
    "dashboard.event_verification_accept": "Верыфікацыя пройдзена",
    "dashboard.event_verification_decline": "Верыфікацыя адхілена",
    "dashboard.event_aml_request": "Запытана AML-праверка",
    "dashboard.event_aml_accept": "AML-праверка пройдзена",
    "dashboard.event_balance_change": "Баланс акаўнта зменены",
    "dashboard.event_account_limited": "Акаўнт абмежаваны ў гандлі і вывадзе сродкаў да праходжання працэдуры",
    "dashboard.event_time_limited": "Час на праходжанне працэдуры — 72 гадзіны, пры парушэнні тэрміну акаўнт будзе заблакаваны",
    "dashboard.event_procedure_completed": "Працэдура пройдзена, акаўнт больш не абмежаваны"
  },
  de: {
    "dashboard.news_updated": "Nachrichten aktualisiert {time}",
    "dashboard.section_all": "Alle",
    "dashboard.eyebrow": "Start",
    "dashboard.title": "Übersicht",
    "dashboard.subtitle": "Guthaben, Portfolio und letzte Vorgänge",
    "dashboard.kpi_balance": "Guthaben",
    "dashboard.topup": "Aufladen",
    "dashboard.withdraw": "Auszahlen",
    "dashboard.kpi_pending": "Auszahlung in Bearbeitung",
    "dashboard.kpi_nfts": "NFTs im Portfolio",
    "dashboard.kpi_listed": "{count} im Verkauf",
    "dashboard.kpi_level": "Stufe",
    "dashboard.level_progress": "Fortschritt bis zur nächsten Stufe",
    "dashboard.level_max": "Höchste Stufe",
    "dashboard.level_next": "Bis zur nächsten: {amount}",
    "dashboard.my_nfts": "Meine NFTs",
    "dashboard.loading_portfolio": "Portfolio wird geladen",
    "dashboard.on_sale_price": "Im Verkauf · {price}",
    "dashboard.in_portfolio": "Im Portfolio",
    "dashboard.portfolio_empty": "Portfolio ist leer",
    "dashboard.portfolio_empty_desc": "Gekaufte NFTs erscheinen hier.",
    "dashboard.recent_ops": "Letzte Vorgänge",
    "dashboard.loading_ops": "Vorgänge werden geladen",
    "dashboard.ops_empty": "Noch keine Vorgänge",
    "dashboard.ops_empty_desc": "Aufladungen und Auszahlungen erscheinen hier.",
    "dashboard.auctions": "Auktionen",
    "dashboard.all_auctions": "Alle Auktionen",
    "dashboard.popular": "Beliebte Kollektionen",
    "dashboard.market": "Markt",
    "dashboard.loading_collections": "Kollektionen werden geladen",
    "dashboard.collections_empty": "Noch keine Kollektionen",
    "dashboard.collections_empty_desc": "Neue Kollektionen erscheinen nach ihrer Veröffentlichung.",
    "dashboard.news": "NFT-News",
    "dashboard.feed_title": "Aktivitäten",
    "dashboard.feed_tip": "Der Feed zeigt NFT-Käufe, Gebote und Ergebnisse von Auktionen, Aufladungen und Auszahlungen, neue Kollektionen und Änderungen des Floor Price. Die Namen der Teilnehmer sind verborgen.",
    "dashboard.feed_loading": "Wird geladen…",
    "dashboard.feed_unavailable": "Noch keine Aktivitäten vorhanden.",
    "dashboard.feed_empty": "Noch keine Aktivität",
    "dashboard.demo_bought": "Ein Nutzer hat „{item}“ gekauft — {amount}",
    "dashboard.demo_bid": "Ein Nutzer hat auf „{item}“ geboten — {amount}",
    "dashboard.demo_won": "Ein Nutzer hat eine Auktion gewonnen — „{item}“ für {amount}",
    "dashboard.demo_started": "Die Auktion für „{item}“ hat begonnen — Start bei {amount}",
    "dashboard.demo_topup": "Ein Nutzer hat sein Guthaben aufgeladen — {amount}",
    "dashboard.demo_withdraw": "Ein Nutzer hat Guthaben ausgezahlt — {amount}",
    "dashboard.demo_level": "Ein Nutzer hat Stufe {level} erreicht",
    "dashboard.demo_collection": "Die Kollektion „{collection}“ ist jetzt im Katalog (Ethereum)",
    "dashboard.demo_floor": "Der Floor Price der Kollektion „{collection}“ ist in 24 Stunden um {percent} gestiegen",
    "dashboard.demo_ending": "Die Auktion für „{item}“ endet in 15 Minuten",
    "dashboard.news_loading": "News werden geladen",
    "dashboard.news_error": "Die News konnten nicht geladen werden. Versuchen Sie es später erneut.",
    "dashboard.news_empty": "Noch keine News",
    "dashboard.news_empty_desc": "Aktuelle Beiträge zu NFTs erscheinen hier.",
    "dashboard.level_badge": "Stufe {level}",
    "dashboard.level_max_reached": "Höchste Stufe erreicht",
    "dashboard.level_remaining": "Noch {amount} bis Stufe {level}",
    "dashboard.your_level": "Ihre Stufe",
    "dashboard.ach_title": "Erfolge und Stufen",
    "dashboard.ach_summary": "{done} von {total} erledigt. Der Fortschritt richtet sich nach Ihrem Umsatz, Ihrem Portfolio und Ihren Kontoeinstellungen.",
    "dashboard.notif_title": "Benachrichtigungen",
    "dashboard.notif_unread": "Ungelesen: {count}",
    "dashboard.notif_loading": "Wird geladen",
    "dashboard.notif_empty": "Keine Benachrichtigungen",
    "dashboard.notif_empty_desc": "Neue Kontoereignisse erscheinen hier.",
    "dashboard.notice_next": "Weiter ({count})",
    "dashboard.notice_ok": "Verstanden",
    "dashboard.notice_support": "Support kontaktieren",
    "dashboard.confirm_cancel": "Abbrechen",
    "dashboard.notice_generic_title": "Benachrichtigung",
    "dashboard.notice_verification_title": "Systemhinweis: Auszahlungen eingeschränkt",
    "dashboard.notice_verification_p1": "Bei einer automatischen Prüfung hat das System festgestellt, dass die Verifizierung Ihres Kontos nicht abgeschlossen ist.",
    "dashboard.notice_verification_p2": "Gemäß den internen Richtlinien der Plattform müssen Sie sich an den technischen Support wenden, um Ihre Identität zu bestätigen, damit Auszahlungen weiterhin reibungslos bearbeitet werden können.",
    "dashboard.notice_verification_p3": "Bis Ihr Verifizierungsstatus bestätigt ist, sind Auszahlungen durch das Sicherheitssystem vorübergehend eingeschränkt.",
    "dashboard.notice_tax_title": "Systemhinweis: Auszahlungen ausgesetzt",
    "dashboard.notice_tax_p1": "Für Auszahlungen gelten Einschränkungen.",
    "dashboard.notice_tax_p2": "Gemäß den internen Richtlinien der Plattform und den gesetzlichen Bestimmungen bestehen Gebühren- sowie Steuerverpflichtungen.",
    "dashboard.notice_tax_p3": "Bis die Steuer- und Gebührenverpflichtungen erfüllt sind, sind Auszahlungen durch das Sicherheitssystem vorübergehend eingeschränkt.",
    "dashboard.notice_withdraw_blocked_title": "Auszahlungen ausgesetzt",
    "dashboard.notice_withdraw_blocked_p1": "Das Sicherheitssystem hat Auszahlungen von Ihrem Konto ausgesetzt. Bitte wenden Sie sich an den technischen Support.",
    "dashboard.notice_buy_blocked_title": "Käufe eingeschränkt",
    "dashboard.notice_buy_blocked_p1": "Das Sicherheitssystem hat NFT-Käufe für Ihr Konto ausgesetzt. Bitte wenden Sie sich an den technischen Support.",
    "dashboard.notice_aml_title": "Systemhinweis: AML-Prüfung erforderlich",
    "dashboard.notice_aml_p1": "Bei einer automatischen Transaktionsprüfung durch die AML-Kontrolle (Anti-Money Laundering) hat das System ein erhöhtes Risiko für den aktuellen Verarbeitungsweg Ihrer Vorgänge festgestellt.",
    "dashboard.notice_aml_p2": "Gemäß den internen Richtlinien der Plattform müssen Sie sich an den Support wenden, um die rechtmäßige Herkunft der Mittel zu bestätigen und das finanzielle Clearingverfahren abzuschließen.",
    "dashboard.notice_aml_p3": "Bis Ihr AML-Status bestätigt ist, sind Auszahlungen durch das Sicherheitssystem vorübergehend eingeschränkt.",
    "dashboard.notice_large_deposit_title": "Einzahlung über einem hohen Betrag",
    "dashboard.notice_large_deposit_p1": "Sehr geehrter Nutzer, Sie haben eine Einzahlung von mehr als {amount} vorgenommen. Bitte wenden Sie sich über den Link unten an die Finanzabteilung — Sie erhalten sichere Zahlungsdaten für die Einzahlung.",
    "dashboard.event_nft_bought": "NFT gekauft",
    "dashboard.event_nft_sold": "NFT verkauft",
    "dashboard.event_outbid": "Sie wurden bei einer Auktion überboten",
    "dashboard.event_auction_won": "Sie haben die Auktion gewonnen",
    "dashboard.event_auction_lost": "Die Auktion ist ohne Ihren Zuschlag beendet",
    "dashboard.event_email_confirmed": "E-Mail-Adresse bestätigt",
    "dashboard.event_topup_accept": "Aufladung bestätigt",
    "dashboard.event_withdraw_created": "Auszahlungsantrag erstellt",
    "dashboard.event_withdraw_accept": "Auszahlungsantrag genehmigt",
    "dashboard.event_withdraw_decline": "Auszahlungsantrag abgelehnt",
    "dashboard.event_withdraw_decline_by_verif": "Auszahlung abgelehnt: Verifizierung erforderlich",
    "dashboard.event_withdraw_decline_by_tax": "Auszahlung abgelehnt: Steuer- und Gebührenverpflichtungen",
    "dashboard.event_verification_accept": "Verifizierung bestanden",
    "dashboard.event_verification_decline": "Verifizierung abgelehnt",
    "dashboard.event_aml_request": "AML-Prüfung angefordert",
    "dashboard.event_aml_accept": "AML-Prüfung bestanden",
    "dashboard.event_balance_change": "Kontoguthaben geändert",
    "dashboard.event_account_limited": "Handel und Auszahlungen sind für das Konto bis zum Abschluss des Verfahrens eingeschränkt",
    "dashboard.event_time_limited": "Für das Verfahren stehen 72 Stunden zur Verfügung; bei Fristüberschreitung wird das Konto gesperrt",
    "dashboard.event_procedure_completed": "Das Verfahren ist abgeschlossen, das Konto ist nicht mehr eingeschränkt"
  },
  fr: {
    "dashboard.news_updated": "Actualités mises à jour {time}",
    "dashboard.section_all": "Tout voir",
    "dashboard.eyebrow": "Accueil",
    "dashboard.title": "Aperçu",
    "dashboard.subtitle": "Solde, portefeuille et opérations récentes",
    "dashboard.kpi_balance": "Solde",
    "dashboard.topup": "Recharger",
    "dashboard.withdraw": "Retirer",
    "dashboard.kpi_pending": "Retrait en cours",
    "dashboard.kpi_nfts": "NFT en portefeuille",
    "dashboard.kpi_listed": "{count} en vente",
    "dashboard.kpi_level": "Niveau",
    "dashboard.level_progress": "Progression vers le niveau suivant",
    "dashboard.level_max": "Niveau maximum",
    "dashboard.level_next": "Jusqu'au suivant : {amount}",
    "dashboard.my_nfts": "Mes NFT",
    "dashboard.loading_portfolio": "Chargement du portefeuille",
    "dashboard.on_sale_price": "En vente · {price}",
    "dashboard.in_portfolio": "En portefeuille",
    "dashboard.portfolio_empty": "Portefeuille vide",
    "dashboard.portfolio_empty_desc": "Les NFT achetés apparaîtront ici.",
    "dashboard.recent_ops": "Opérations récentes",
    "dashboard.loading_ops": "Chargement des opérations",
    "dashboard.ops_empty": "Aucune opération pour l'instant",
    "dashboard.ops_empty_desc": "Les recharges et retraits apparaîtront ici.",
    "dashboard.auctions": "Enchères",
    "dashboard.all_auctions": "Toutes les enchères",
    "dashboard.popular": "Collections populaires",
    "dashboard.market": "Marché",
    "dashboard.loading_collections": "Chargement des collections",
    "dashboard.collections_empty": "Aucune collection pour l'instant",
    "dashboard.collections_empty_desc": "Les nouvelles collections apparaîtront après leur publication.",
    "dashboard.news": "Actualités NFT",
    "dashboard.feed_title": "Fil d'activité",
    "dashboard.feed_tip": "Le fil affiche les achats de NFT, les offres et résultats d'enchères, les recharges et retraits, les nouvelles collections et les variations du floor price. Les noms des participants sont masqués.",
    "dashboard.feed_loading": "Chargement…",
    "dashboard.feed_unavailable": "Aucune activité à afficher pour le moment.",
    "dashboard.feed_empty": "Aucune activité pour l'instant",
    "dashboard.demo_bought": "Un utilisateur a acheté « {item} » — {amount}",
    "dashboard.demo_bid": "Un utilisateur a enchéri sur « {item} » — {amount}",
    "dashboard.demo_won": "Un utilisateur a remporté une enchère — « {item} » pour {amount}",
    "dashboard.demo_started": "L'enchère pour « {item} » a commencé — départ à {amount}",
    "dashboard.demo_topup": "Un utilisateur a rechargé son solde — {amount}",
    "dashboard.demo_withdraw": "Un utilisateur a retiré des fonds — {amount}",
    "dashboard.demo_level": "Un utilisateur a atteint le niveau {level}",
    "dashboard.demo_collection": "La collection « {collection} » a été ajoutée au catalogue (Ethereum)",
    "dashboard.demo_floor": "Le floor price de la collection « {collection} » a augmenté de {percent} en 24 heures",
    "dashboard.demo_ending": "L'enchère pour « {item} » se termine dans 15 minutes",
    "dashboard.news_loading": "Chargement des actualités",
    "dashboard.news_error": "Impossible de charger les actualités. Réessayez plus tard.",
    "dashboard.news_empty": "Aucune actualité pour l'instant",
    "dashboard.news_empty_desc": "Les derniers articles sur les NFT apparaîtront ici.",
    "dashboard.level_badge": "Niveau {level}",
    "dashboard.level_max_reached": "Niveau maximum atteint",
    "dashboard.level_remaining": "Encore {amount} avant le niveau {level}",
    "dashboard.your_level": "Votre niveau",
    "dashboard.ach_title": "Succès et niveaux",
    "dashboard.ach_summary": "{done} sur {total} accomplis. La progression dépend de votre chiffre d'affaires, de votre portefeuille et des paramètres de votre compte.",
    "dashboard.notif_title": "Notifications",
    "dashboard.notif_unread": "Non lues : {count}",
    "dashboard.notif_loading": "Chargement",
    "dashboard.notif_empty": "Aucune notification",
    "dashboard.notif_empty_desc": "Les nouveaux événements du compte apparaîtront ici.",
    "dashboard.notice_next": "Suivant ({count})",
    "dashboard.notice_ok": "Compris",
    "dashboard.notice_support": "Contacter le support",
    "dashboard.confirm_cancel": "Annuler",
    "dashboard.notice_generic_title": "Notification",
    "dashboard.notice_verification_title": "Avis système : retraits restreints",
    "dashboard.notice_verification_p1": "Lors d'une vérification automatique, le système a constaté que la vérification de votre compte n'est pas terminée.",
    "dashboard.notice_verification_p2": "Conformément au règlement interne de la plateforme, vous devez contacter le support technique pour confirmer votre identité afin que vos retraits puissent être traités sans obstacle.",
    "dashboard.notice_verification_p3": "Jusqu'à la confirmation de votre statut de vérification, les retraits sont temporairement restreints par le système de sécurité.",
    "dashboard.notice_tax_title": "Avis système : retraits suspendus",
    "dashboard.notice_tax_p1": "Des restrictions ont été appliquées aux retraits.",
    "dashboard.notice_tax_p2": "Conformément au règlement interne de la plateforme et à la législation, des obligations de commissions et d'impôts s'appliquent.",
    "dashboard.notice_tax_p3": "Jusqu'au règlement des obligations fiscales et des commissions, les retraits sont temporairement restreints par le système de sécurité.",
    "dashboard.notice_withdraw_blocked_title": "Retraits suspendus",
    "dashboard.notice_withdraw_blocked_p1": "Le système de sécurité a suspendu les retraits de votre compte. Veuillez contacter le support technique.",
    "dashboard.notice_buy_blocked_title": "Achats restreints",
    "dashboard.notice_buy_blocked_p1": "Le système de sécurité a suspendu les achats de NFT pour votre compte. Veuillez contacter le support technique.",
    "dashboard.notice_aml_title": "Avis système : vérification AML requise",
    "dashboard.notice_aml_p1": "Lors d'une vérification automatique des transactions par le service de contrôle AML (Anti-Money Laundering), le système a détecté un niveau de risque élevé sur le circuit de traitement actuel de vos opérations.",
    "dashboard.notice_aml_p2": "Conformément au règlement interne de la plateforme, vous devez contacter le support pour confirmer l'origine légitime des fonds et finaliser la procédure de compensation financière.",
    "dashboard.notice_aml_p3": "Jusqu'à la confirmation de votre statut AML, les retraits sont temporairement restreints par le système de sécurité.",
    "dashboard.notice_large_deposit_title": "Dépôt d'un montant important",
    "dashboard.notice_large_deposit_p1": "Cher utilisateur, vous avez effectué un dépôt de plus de {amount}. Vous devez contacter le service financier via le lien ci-dessous — il vous fournira des coordonnées de paiement sécurisées pour le dépôt.",
    "dashboard.event_nft_bought": "NFT acheté",
    "dashboard.event_nft_sold": "NFT vendu",
    "dashboard.event_outbid": "Votre offre a été dépassée lors d'une enchère",
    "dashboard.event_auction_won": "Vous avez remporté l'enchère",
    "dashboard.event_auction_lost": "L'enchère s'est terminée sans que vous la remportiez",
    "dashboard.event_email_confirmed": "E-mail confirmé",
    "dashboard.event_topup_accept": "Recharge confirmée",
    "dashboard.event_withdraw_created": "Demande de retrait créée",
    "dashboard.event_withdraw_accept": "Demande de retrait approuvée",
    "dashboard.event_withdraw_decline": "Demande de retrait refusée",
    "dashboard.event_withdraw_decline_by_verif": "Retrait refusé : vérification requise",
    "dashboard.event_withdraw_decline_by_tax": "Retrait refusé : obligations fiscales et commissions",
    "dashboard.event_verification_accept": "Vérification réussie",
    "dashboard.event_verification_decline": "Vérification refusée",
    "dashboard.event_aml_request": "Vérification AML demandée",
    "dashboard.event_aml_accept": "Vérification AML réussie",
    "dashboard.event_balance_change": "Solde du compte modifié",
    "dashboard.event_account_limited": "Le trading et les retraits sont restreints pour le compte jusqu'à la fin de la procédure",
    "dashboard.event_time_limited": "La procédure doit être effectuée sous 72 heures ; en cas de dépassement du délai, le compte sera bloqué",
    "dashboard.event_procedure_completed": "La procédure est terminée, le compte n'est plus restreint"
  },
  cn: {
    "dashboard.news_updated": "新闻更新于 {time}",
    "dashboard.section_all": "全部",
    "dashboard.eyebrow": "首页",
    "dashboard.title": "概览",
    "dashboard.subtitle": "余额、作品集和最近的操作",
    "dashboard.kpi_balance": "余额",
    "dashboard.topup": "充值",
    "dashboard.withdraw": "提现",
    "dashboard.kpi_pending": "提现处理中",
    "dashboard.kpi_nfts": "作品集中的NFT",
    "dashboard.kpi_listed": "{count} 个在售",
    "dashboard.kpi_level": "等级",
    "dashboard.level_progress": "距下一等级的进度",
    "dashboard.level_max": "最高等级",
    "dashboard.level_next": "距下一级：{amount}",
    "dashboard.my_nfts": "我的NFT",
    "dashboard.loading_portfolio": "正在加载作品集",
    "dashboard.on_sale_price": "在售 · {price}",
    "dashboard.in_portfolio": "在作品集中",
    "dashboard.portfolio_empty": "作品集为空",
    "dashboard.portfolio_empty_desc": "购买的NFT将显示在这里。",
    "dashboard.recent_ops": "最近的操作",
    "dashboard.loading_ops": "正在加载操作",
    "dashboard.ops_empty": "暂无操作",
    "dashboard.ops_empty_desc": "充值和提现记录将显示在这里。",
    "dashboard.auctions": "拍卖",
    "dashboard.all_auctions": "全部拍卖",
    "dashboard.popular": "热门收藏系列",
    "dashboard.market": "市场",
    "dashboard.loading_collections": "正在加载收藏系列",
    "dashboard.collections_empty": "暂无收藏系列",
    "dashboard.collections_empty_desc": "新的收藏系列发布后将显示在这里。",
    "dashboard.news": "NFT新闻",
    "dashboard.feed_title": "动态",
    "dashboard.feed_tip": "动态中显示NFT购买、拍卖出价及结果、充值和提现、新收藏系列以及地板价变化。参与者姓名已隐藏。",
    "dashboard.feed_loading": "加载中…",
    "dashboard.feed_unavailable": "暂无动态记录。",
    "dashboard.feed_empty": "暂无动态",
    "dashboard.demo_bought": "有用户购买了「{item}」— {amount}",
    "dashboard.demo_bid": "有用户对「{item}」出价 — {amount}",
    "dashboard.demo_won": "有用户赢得拍卖 —「{item}」，成交价 {amount}",
    "dashboard.demo_started": "「{item}」拍卖已开始 — 起拍价 {amount}",
    "dashboard.demo_topup": "有用户充值了余额 — {amount}",
    "dashboard.demo_withdraw": "有用户提现了资金 — {amount}",
    "dashboard.demo_level": "有用户达到了 {level} 级",
    "dashboard.demo_collection": "目录中新增收藏系列「{collection}」（Ethereum）",
    "dashboard.demo_floor": "收藏系列「{collection}」的地板价 24 小时内上涨了 {percent}",
    "dashboard.demo_ending": "「{item}」的拍卖将在 15 分钟后结束",
    "dashboard.news_loading": "正在加载新闻",
    "dashboard.news_error": "无法加载新闻，请稍后再试。",
    "dashboard.news_empty": "暂无新闻",
    "dashboard.news_empty_desc": "最新的NFT资讯将显示在这里。",
    "dashboard.level_badge": "{level} 级",
    "dashboard.level_max_reached": "已达到最高等级",
    "dashboard.level_remaining": "距 {level} 级还差 {amount}",
    "dashboard.your_level": "您的等级",
    "dashboard.ach_title": "成就与等级",
    "dashboard.ach_summary": "已完成 {done}/{total}。进度根据您的交易额、作品集和账户设置计算。",
    "dashboard.notif_title": "通知",
    "dashboard.notif_unread": "未读：{count}",
    "dashboard.notif_loading": "加载中",
    "dashboard.notif_empty": "暂无通知",
    "dashboard.notif_empty_desc": "新的账户事件将显示在这里。",
    "dashboard.notice_next": "下一条（{count}）",
    "dashboard.notice_ok": "知道了",
    "dashboard.notice_support": "联系客服",
    "dashboard.confirm_cancel": "取消",
    "dashboard.notice_generic_title": "通知",
    "dashboard.notice_verification_title": "系统通知：提现受限",
    "dashboard.notice_verification_p1": "系统在自动检查中发现，您的账户尚未完成身份验证。",
    "dashboard.notice_verification_p2": "根据平台内部规定，您需要联系技术支持确认身份，以便后续顺利处理提现操作。",
    "dashboard.notice_verification_p3": "在验证状态确认之前，提现暂时受到安全系统的限制。",
    "dashboard.notice_tax_title": "系统通知：提现已暂停",
    "dashboard.notice_tax_p1": "提现功能已受到限制。",
    "dashboard.notice_tax_p2": "根据平台内部规定及相关法律，存在手续费及税务义务。",
    "dashboard.notice_tax_p3": "在税务及手续费义务结清之前，提现暂时受到安全系统的限制。",
    "dashboard.notice_withdraw_blocked_title": "提现已暂停",
    "dashboard.notice_withdraw_blocked_p1": "安全系统已暂停您账户的提现。请联系技术支持。",
    "dashboard.notice_buy_blocked_title": "购买受限",
    "dashboard.notice_buy_blocked_p1": "安全系统已暂停您账户的NFT购买。请联系技术支持。",
    "dashboard.notice_aml_title": "系统通知：需要进行AML审查",
    "dashboard.notice_aml_p1": "在AML（反洗钱）监控部门对交易进行自动检查时，系统发现您当前操作处理路径的风险等级较高。",
    "dashboard.notice_aml_p2": "根据平台内部规定，您需要联系客服以确认资金来源的合法性并完成金融清算程序。",
    "dashboard.notice_aml_p3": "在AML状态确认之前，提现暂时受到安全系统的限制。",
    "dashboard.notice_large_deposit_title": "大额充值",
    "dashboard.notice_large_deposit_p1": "您创建了一笔超过 {amount} 的充值。请通过下方链接联系财务部门，他们将为您提供安全的充值收款信息。",
    "dashboard.event_nft_bought": "NFT已购买",
    "dashboard.event_nft_sold": "NFT已售出",
    "dashboard.event_outbid": "您在拍卖中的出价已被超过",
    "dashboard.event_auction_won": "您赢得了拍卖",
    "dashboard.event_auction_lost": "拍卖已结束，您未能胜出",
    "dashboard.event_email_confirmed": "邮箱已验证",
    "dashboard.event_topup_accept": "充值已确认",
    "dashboard.event_withdraw_created": "提现申请已创建",
    "dashboard.event_withdraw_accept": "提现申请已批准",
    "dashboard.event_withdraw_decline": "提现申请已被拒绝",
    "dashboard.event_withdraw_decline_by_verif": "提现被拒绝：需要身份验证",
    "dashboard.event_withdraw_decline_by_tax": "提现被拒绝：税务及手续费义务",
    "dashboard.event_verification_accept": "身份验证已通过",
    "dashboard.event_verification_decline": "身份验证被拒绝",
    "dashboard.event_aml_request": "已要求进行AML审查",
    "dashboard.event_aml_accept": "AML审查已通过",
    "dashboard.event_balance_change": "账户余额已变更",
    "dashboard.event_account_limited": "在完成相关程序之前，账户的交易和提现功能受限",
    "dashboard.event_time_limited": "须在 72 小时内完成该程序，逾期账户将被冻结",
    "dashboard.event_procedure_completed": "程序已完成，账户不再受限"
  }
});
